/**
 * Точность геометки: где проходит граница между «точка» и «примерный район».
 *
 * Порог совпадает с ACCURACY_TRUSTED_M в backend/app/services/geo.py: сервер
 * по нему помечает точку неточной, клиент по нему же подсказывает няне.
 */

export const ACCURACY_TRUSTED_M = 500

/** «±40 м», «±3,6 км» — радиус так, как его прочитает человек. */
export function formatAccuracy(meters: number): string {
  if (meters < 1000) return `±${Math.round(meters)} м`
  const km = meters / 1000
  return `±${km.toLocaleString('ru-RU', { maximumFractionDigits: km < 10 ? 1 : 0 })} км`
}
